const ACCESS_TOKEN_KEY = 'accessToken';
const USER_ID_KEY = 'id';

export interface Storage {
  getAccessToken: () => string | null;
  setAccessToken: (token: string) => void;
  removeAccessToken: () => void;

  getUserId: () => string | null;
  setUserId: (userId: number) => void;
  removeUserId: () => void;

  clearSession: () => void;
}

const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
const setAccessToken = (token: string) => localStorage.setItem(ACCESS_TOKEN_KEY, token);
const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);

const getUserId = () => localStorage.getItem(USER_ID_KEY);
const setUserId = (userId: number) => localStorage.setItem(USER_ID_KEY, userId.toString());
const removeUserId = () => localStorage.removeItem(USER_ID_KEY);

const clearSession = () => {
  removeAccessToken();
  removeUserId();
};

const storage: Storage = {
  getAccessToken,
  setAccessToken,
  removeAccessToken,
  getUserId,
  setUserId,
  removeUserId,
  clearSession
};

export default storage;
